// extracted by mini-css-extract-plugin
export default {"root":"_2JipG","indicators":"_6PNv-"};